import React from "react";
import { Route, Switch } from "react-router";
import LoginContainer from "../components/Containers/LoginContainer";
import Thanks from "../components/pages/Thanks";
import Welcome from "../components/pages/Welcome";
import PageNotFound from "../components/pages/PageNotFound";
import PrivateRoute from "./Private";
import GuestRoute from "./Guest";
import FormContainer from "../components/Containers/FormContainer";
export const LOGIN = "/login";
export const DIRECT_LOGIN = "/i/:dossier_number/:form_code/:employer_number";
export const HOME = "/";
export const THANKS = "/bedankt";
export const TEMP_ROUTE = "/welcome";
const Routes = () => {
    return (React.createElement(Switch, null,
        React.createElement(GuestRoute, { path: LOGIN, component: LoginContainer }),
        React.createElement(Route, { path: DIRECT_LOGIN, component: LoginContainer }),
        React.createElement(Route, { path: TEMP_ROUTE, component: Welcome }),
        React.createElement(PrivateRoute, { path: THANKS, component: Thanks }),
        React.createElement(PrivateRoute, { path: HOME, component: FormContainer }),
        React.createElement(Route, { component: PageNotFound })));
};
export default Routes;
